"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanvasItem = exports.CanvasContainer = exports.CanvasBox = void 0;
const react_1 = __importDefault(require("react"));
const styles_1 = require("./styles");
const CanvasBox = (props) => {
    const { children } = props, rest = __rest(props, ["children"]);
    return (react_1.default.createElement(styles_1.StyledBox, Object.assign({ "data-cy": 'canvas-box' }, rest), children));
};
exports.CanvasBox = CanvasBox;
const CanvasContainer = (props) => {
    const { children } = props, rest = __rest(props, ["children"]);
    return (react_1.default.createElement(styles_1.StyledContainer, Object.assign({ "data-cy": 'canvas-container' }, rest), children));
};
exports.CanvasContainer = CanvasContainer;
const CanvasItem = (props) => {
    const { children } = props, rest = __rest(props, ["children"]);
    return (react_1.default.createElement(styles_1.StyledItem, Object.assign({ "data-cy": 'canvas-item' }, rest), children));
};
exports.CanvasItem = CanvasItem;
